/**
 * AudioContext Keep-Alive
 *
 * Mantém o pipeline de áudio do navegador ativo indefinidamente,
 * impedindo que a autoplay policy suspenda notificações sonoras
 * após períodos de inatividade.
 *
 * Funcionamento:
 * 1. Na primeira interação do usuário, cria um AudioContext
 * 2. A cada 25s, reproduz um pulso silencioso (gain ≈ 0) para manter a sessão "quente"
 * 3. Ao voltar para a aba, faz resume() imediato do AudioContext
 */

let audioCtx = null;
let keepAliveInterval = null;

function silentPing() {
  if (!audioCtx || audioCtx.state !== "running") return;
  try {
    const osc = audioCtx.createOscillator();
    const gain = audioCtx.createGain();
    gain.gain.value = 0.001;
    osc.connect(gain);
    gain.connect(audioCtx.destination);
    osc.start();
    osc.stop(audioCtx.currentTime + 0.001);
  } catch (_) {}
}

function resumeCtx() {
  if (audioCtx && audioCtx.state === "suspended") {
    audioCtx.resume().catch(() => {});
  }
}

function ensureCtx() {
  if (!audioCtx) {
    try {
      audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    } catch (_) {
      return;
    }
  }
  resumeCtx();
  if (!keepAliveInterval) {
    silentPing();
    keepAliveInterval = setInterval(silentPing, 25000);
  }
}

export function initAudioKeepAlive() {
  const events = ["click", "touchstart", "keydown"];
  const handler = () => { ensureCtx(); };
  events.forEach(e => document.addEventListener(e, handler, { capture: true, passive: true }));
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") resumeCtx();
  });
}
